var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jiugonggeBox"},[_c('p',{staticClass:"jiugonggeBox_logo"},[_c('img',{attrs:{"src":_vm.options.data.logo,"alt":""}})]),_c('p',{staticClass:"jiugonggeBox_txt text3"},[_vm._v(_vm._s(_vm.options.data.desc))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }